import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Icons.css';

const HeartEmpty = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M18.04 2.06499C15.54 1.65999 13.345 3.15999 12 6.12999C10.65 3.15999 8.45 1.65499 5.955 2.06499C3.175 2.49999 1 5.31999 1 8.43499C1 14.905 8.745 19.935 11.295 21.61L11.755 21.915C11.8378 21.9706 11.9353 22.0002 12.035 22C12.1226 22.0006 12.2088 21.9782 12.285 21.935C14.075 20.935 23 15.465 23 8.43499C23 5.31499 20.82 2.49999 18.04 2.06499ZM12.04 20.91C11.97 20.87 11.9 20.82 11.825 20.77C9.405 19.185 2 14.36 2 8.43499C2 5.79499 3.81 3.43499 6.115 3.05499C6.31814 3.01976 6.52384 3.00137 6.73 2.99999C8.765 2.99999 10.525 4.69499 11.525 7.65999C11.5579 7.76003 11.6215 7.84713 11.7068 7.90888C11.7921 7.97063 11.8947 8.00387 12 8.00387C12.1053 8.00387 12.2079 7.97063 12.2932 7.90888C12.3785 7.84713 12.4421 7.76003 12.475 7.65999C13.565 4.39999 15.59 2.65999 17.88 3.05499C19.905 3.38499 22 5.49999 22 8.43499C22 14.625 14.23 19.63 12.055 20.91H12.04Z"
        fill="current"
      />
    </svg>
  );
};

const { string } = PropTypes;

HeartEmpty.defaultProps = {
  className: null,
  rootClassName: null,
};

HeartEmpty.propTypes = {
  className: string,
  rootClassName: string,
};

export default HeartEmpty;
